const getStripe = () => {
  return false;
};

export default getStripe;